module.exports = __webpack_public_path__ + "static/media/Captain-Picard-Facepalm.71dabbd0.jpg";